var render = function render(_c,_vm){return (_vm.$options.methods.getComponent(_vm.props.field, _vm.parent.$registry))?_c(_vm.$options.methods.getComponent(_vm.props.field, _vm.parent.$registry),{tag:"component",attrs:{"row":_vm.props.row,"field":_vm.props.field,"value":_vm.props.value}}):_c('div',{staticClass:"grid-view__cell cell-error"},[_vm._v("Unknown Field Type")])
}
var staticRenderFns = []

export { render, staticRenderFns }